// source: no/jotta/openapi/auth/v2/auth.v2.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var no_jotta_openapi_ping_pb = require('../../../../../no/jotta/openapi/ping_pb.js');
goog.object.extend(proto, no_jotta_openapi_ping_pb);
var no_jotta_openapi_credentials_pb = require('../../../../../no/jotta/openapi/credentials_pb.js');
goog.object.extend(proto, no_jotta_openapi_credentials_pb);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.ConfirmTFARequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmSMSTFARequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmTOTPRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.TypeCase', null, global);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.ConfirmTFAResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.ConfirmTFAResponse.ConfirmTFAStatus', null, global);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.DeleteSessionRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.DeleteSessionResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.DisableTFARequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.DisableTFAResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.Event', null, global);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.Event.EventType', null, global);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.GenerateLoginTokenRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.GenerateLoginTokenResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.InitializeTFARequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeSMSTFARequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeTOTPRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.InitializeTFARequest.TypeCase', null, global);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.InitializeTFAResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeSMSTFAResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.TypeCase', null, global);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.LinkedIdentity', null, global);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.ListEventsRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.ListEventsResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.ListSessionsRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.ListSessionsResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.RegisterSessionRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.RegisterSessionResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.Session', null, global);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.Session.SessionType', null, global);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.UnlinkIdentityRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.auth.v2.UnlinkIdentityResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.auth.v2.Session = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.auth.v2.Session, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.auth.v2.Session.displayName = 'proto.no.jotta.openapi.auth.v2.Session';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.auth.v2.Event = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.auth.v2.Event, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.auth.v2.Event.displayName = 'proto.no.jotta.openapi.auth.v2.Event';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.auth.v2.LinkedIdentity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.auth.v2.LinkedIdentity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.auth.v2.LinkedIdentity.displayName = 'proto.no.jotta.openapi.auth.v2.LinkedIdentity';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.auth.v2.ListSessionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.auth.v2.ListSessionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.auth.v2.ListSessionsRequest.displayName = 'proto.no.jotta.openapi.auth.v2.ListSessionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.auth.v2.ListSessionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.auth.v2.ListSessionsResponse.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.auth.v2.ListSessionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.auth.v2.ListSessionsResponse.displayName = 'proto.no.jotta.openapi.auth.v2.ListSessionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.auth.v2.DeleteSessionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.auth.v2.DeleteSessionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.auth.v2.DeleteSessionRequest.displayName = 'proto.no.jotta.openapi.auth.v2.DeleteSessionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.auth.v2.DeleteSessionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.auth.v2.DeleteSessionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.auth.v2.DeleteSessionResponse.displayName = 'proto.no.jotta.openapi.auth.v2.DeleteSessionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.auth.v2.ListEventsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.auth.v2.ListEventsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.auth.v2.ListEventsRequest.displayName = 'proto.no.jotta.openapi.auth.v2.ListEventsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.auth.v2.ListEventsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.auth.v2.ListEventsResponse.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.auth.v2.ListEventsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.auth.v2.ListEventsResponse.displayName = 'proto.no.jotta.openapi.auth.v2.ListEventsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.auth.v2.GenerateLoginTokenRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.auth.v2.GenerateLoginTokenRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.auth.v2.GenerateLoginTokenRequest.displayName = 'proto.no.jotta.openapi.auth.v2.GenerateLoginTokenRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.auth.v2.GenerateLoginTokenResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.auth.v2.GenerateLoginTokenResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.auth.v2.GenerateLoginTokenResponse.displayName = 'proto.no.jotta.openapi.auth.v2.GenerateLoginTokenResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesRequest.displayName = 'proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesResponse.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesResponse.displayName = 'proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingRequest.displayName = 'proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingResponse.displayName = 'proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.auth.v2.UnlinkIdentityRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.auth.v2.UnlinkIdentityRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.auth.v2.UnlinkIdentityRequest.displayName = 'proto.no.jotta.openapi.auth.v2.UnlinkIdentityRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.auth.v2.UnlinkIdentityResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.auth.v2.UnlinkIdentityResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.auth.v2.UnlinkIdentityResponse.displayName = 'proto.no.jotta.openapi.auth.v2.UnlinkIdentityResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.auth.v2.InitializeTFARequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.no.jotta.openapi.auth.v2.InitializeTFARequest.oneofGroups_);
};
goog.inherits(proto.no.jotta.openapi.auth.v2.InitializeTFARequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.auth.v2.InitializeTFARequest.displayName = 'proto.no.jotta.openapi.auth.v2.InitializeTFARequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeTOTPRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeTOTPRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeTOTPRequest.displayName = 'proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeTOTPRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeSMSTFARequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeSMSTFARequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeSMSTFARequest.displayName = 'proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeSMSTFARequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.oneofGroups_);
};
goog.inherits(proto.no.jotta.openapi.auth.v2.InitializeTFAResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.displayName = 'proto.no.jotta.openapi.auth.v2.InitializeTFAResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse.displayName = 'proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeSMSTFAResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeSMSTFAResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeSMSTFAResponse.displayName = 'proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeSMSTFAResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.oneofGroups_);
};
goog.inherits(proto.no.jotta.openapi.auth.v2.ConfirmTFARequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.displayName = 'proto.no.jotta.openapi.auth.v2.ConfirmTFARequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmTOTPRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmTOTPRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmTOTPRequest.displayName = 'proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmTOTPRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmSMSTFARequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmSMSTFARequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmSMSTFARequest.displayName = 'proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmSMSTFARequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFAResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.auth.v2.ConfirmTFAResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.auth.v2.ConfirmTFAResponse.displayName = 'proto.no.jotta.openapi.auth.v2.ConfirmTFAResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.auth.v2.DisableTFARequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.auth.v2.DisableTFARequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.auth.v2.DisableTFARequest.displayName = 'proto.no.jotta.openapi.auth.v2.DisableTFARequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.auth.v2.DisableTFAResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.auth.v2.DisableTFAResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.auth.v2.DisableTFAResponse.displayName = 'proto.no.jotta.openapi.auth.v2.DisableTFAResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.auth.v2.RegisterSessionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.auth.v2.RegisterSessionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.auth.v2.RegisterSessionRequest.displayName = 'proto.no.jotta.openapi.auth.v2.RegisterSessionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.auth.v2.RegisterSessionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.auth.v2.RegisterSessionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.auth.v2.RegisterSessionResponse.displayName = 'proto.no.jotta.openapi.auth.v2.RegisterSessionResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.auth.v2.Session.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.auth.v2.Session.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.auth.v2.Session} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.Session.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ipAddress: jspb.Message.getFieldWithDefault(msg, 2, ""),
    startedAtMillis: jspb.Message.getFieldWithDefault(msg, 3, 0),
    lastAccessedMillis: jspb.Message.getFieldWithDefault(msg, 4, 0),
    deviceName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    clientName: jspb.Message.getFieldWithDefault(msg, 6, ""),
    location: jspb.Message.getFieldWithDefault(msg, 7, ""),
    type: jspb.Message.getFieldWithDefault(msg, 8, 0),
    countryCode: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.auth.v2.Session}
 */
proto.no.jotta.openapi.auth.v2.Session.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.auth.v2.Session;
  return proto.no.jotta.openapi.auth.v2.Session.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.auth.v2.Session} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.auth.v2.Session}
 */
proto.no.jotta.openapi.auth.v2.Session.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setIpAddress(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartedAtMillis(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLastAccessedMillis(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocation(value);
      break;
    case 8:
      var value = /** @type {!proto.no.jotta.openapi.auth.v2.Session.SessionType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountryCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.auth.v2.Session.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.auth.v2.Session.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.auth.v2.Session} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.Session.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIpAddress();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStartedAtMillis();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getLastAccessedMillis();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getDeviceName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getClientName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getLocation();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getCountryCode();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.no.jotta.openapi.auth.v2.Session.SessionType = {
  UNKNOWN: 0,
  WEB: 1,
  DEVICE: 2
};

/**
 * optional string id = 1;
 * @return {string}
 */
proto.no.jotta.openapi.auth.v2.Session.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.auth.v2.Session} returns this
 */
proto.no.jotta.openapi.auth.v2.Session.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ip_address = 2;
 * @return {string}
 */
proto.no.jotta.openapi.auth.v2.Session.prototype.getIpAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.auth.v2.Session} returns this
 */
proto.no.jotta.openapi.auth.v2.Session.prototype.setIpAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 started_at_millis = 3;
 * @return {number}
 */
proto.no.jotta.openapi.auth.v2.Session.prototype.getStartedAtMillis = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.auth.v2.Session} returns this
 */
proto.no.jotta.openapi.auth.v2.Session.prototype.setStartedAtMillis = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 last_accessed_millis = 4;
 * @return {number}
 */
proto.no.jotta.openapi.auth.v2.Session.prototype.getLastAccessedMillis = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.auth.v2.Session} returns this
 */
proto.no.jotta.openapi.auth.v2.Session.prototype.setLastAccessedMillis = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string device_name = 5;
 * @return {string}
 */
proto.no.jotta.openapi.auth.v2.Session.prototype.getDeviceName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.auth.v2.Session} returns this
 */
proto.no.jotta.openapi.auth.v2.Session.prototype.setDeviceName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string client_name = 6;
 * @return {string}
 */
proto.no.jotta.openapi.auth.v2.Session.prototype.getClientName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.auth.v2.Session} returns this
 */
proto.no.jotta.openapi.auth.v2.Session.prototype.setClientName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string location = 7;
 * @return {string}
 */
proto.no.jotta.openapi.auth.v2.Session.prototype.getLocation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.auth.v2.Session} returns this
 */
proto.no.jotta.openapi.auth.v2.Session.prototype.setLocation = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional SessionType type = 8;
 * @return {!proto.no.jotta.openapi.auth.v2.Session.SessionType}
 */
proto.no.jotta.openapi.auth.v2.Session.prototype.getType = function() {
  return /** @type {!proto.no.jotta.openapi.auth.v2.Session.SessionType} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.no.jotta.openapi.auth.v2.Session.SessionType} value
 * @return {!proto.no.jotta.openapi.auth.v2.Session} returns this
 */
proto.no.jotta.openapi.auth.v2.Session.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional string country_code = 9;
 * @return {string}
 */
proto.no.jotta.openapi.auth.v2.Session.prototype.getCountryCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.auth.v2.Session} returns this
 */
proto.no.jotta.openapi.auth.v2.Session.prototype.setCountryCode = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.auth.v2.Event.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.auth.v2.Event.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.auth.v2.Event} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.Event.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    timestamp: jspb.Message.getFieldWithDefault(msg, 2, 0),
    ipAddress: jspb.Message.getFieldWithDefault(msg, 3, ""),
    location: jspb.Message.getFieldWithDefault(msg, 4, ""),
    application: jspb.Message.getFieldWithDefault(msg, 5, ""),
    countryCode: jspb.Message.getFieldWithDefault(msg, 6, ""),
    agentFamily: jspb.Message.getFieldWithDefault(msg, 7, ""),
    agentOs: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.auth.v2.Event}
 */
proto.no.jotta.openapi.auth.v2.Event.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.auth.v2.Event;
  return proto.no.jotta.openapi.auth.v2.Event.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.auth.v2.Event} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.auth.v2.Event}
 */
proto.no.jotta.openapi.auth.v2.Event.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.no.jotta.openapi.auth.v2.Event.EventType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimestamp(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIpAddress(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocation(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplication(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountryCode(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAgentFamily(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setAgentOs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.auth.v2.Event.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.auth.v2.Event.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.auth.v2.Event} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.Event.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getIpAddress();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLocation();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getApplication();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCountryCode();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAgentFamily();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAgentOs();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.no.jotta.openapi.auth.v2.Event.EventType = {
  UNKNOWN: 0,
  LOGIN: 1,
  LOGIN_ERROR: 2,
  SEND_RESET_PASSWORD: 3
};

/**
 * optional EventType type = 1;
 * @return {!proto.no.jotta.openapi.auth.v2.Event.EventType}
 */
proto.no.jotta.openapi.auth.v2.Event.prototype.getType = function() {
  return /** @type {!proto.no.jotta.openapi.auth.v2.Event.EventType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.no.jotta.openapi.auth.v2.Event.EventType} value
 * @return {!proto.no.jotta.openapi.auth.v2.Event} returns this
 */
proto.no.jotta.openapi.auth.v2.Event.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int64 timestamp = 2;
 * @return {number}
 */
proto.no.jotta.openapi.auth.v2.Event.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.auth.v2.Event} returns this
 */
proto.no.jotta.openapi.auth.v2.Event.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string ip_address = 3;
 * @return {string}
 */
proto.no.jotta.openapi.auth.v2.Event.prototype.getIpAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.auth.v2.Event} returns this
 */
proto.no.jotta.openapi.auth.v2.Event.prototype.setIpAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string location = 4;
 * @return {string}
 */
proto.no.jotta.openapi.auth.v2.Event.prototype.getLocation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.auth.v2.Event} returns this
 */
proto.no.jotta.openapi.auth.v2.Event.prototype.setLocation = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string application = 5;
 * @return {string}
 */
proto.no.jotta.openapi.auth.v2.Event.prototype.getApplication = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.auth.v2.Event} returns this
 */
proto.no.jotta.openapi.auth.v2.Event.prototype.setApplication = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string country_code = 6;
 * @return {string}
 */
proto.no.jotta.openapi.auth.v2.Event.prototype.getCountryCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.auth.v2.Event} returns this
 */
proto.no.jotta.openapi.auth.v2.Event.prototype.setCountryCode = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string agent_family = 7;
 * @return {string}
 */
proto.no.jotta.openapi.auth.v2.Event.prototype.getAgentFamily = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.auth.v2.Event} returns this
 */
proto.no.jotta.openapi.auth.v2.Event.prototype.setAgentFamily = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string agent_os = 8;
 * @return {string}
 */
proto.no.jotta.openapi.auth.v2.Event.prototype.getAgentOs = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.auth.v2.Event} returns this
 */
proto.no.jotta.openapi.auth.v2.Event.prototype.setAgentOs = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.auth.v2.LinkedIdentity.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.auth.v2.LinkedIdentity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.auth.v2.LinkedIdentity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.LinkedIdentity.toObject = function(includeInstance, msg) {
  var f, obj = {
    providerId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    providerName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    linked: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.auth.v2.LinkedIdentity}
 */
proto.no.jotta.openapi.auth.v2.LinkedIdentity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.auth.v2.LinkedIdentity;
  return proto.no.jotta.openapi.auth.v2.LinkedIdentity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.auth.v2.LinkedIdentity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.auth.v2.LinkedIdentity}
 */
proto.no.jotta.openapi.auth.v2.LinkedIdentity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProviderId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProviderName(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLinked(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.auth.v2.LinkedIdentity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.auth.v2.LinkedIdentity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.auth.v2.LinkedIdentity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.LinkedIdentity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProviderId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProviderName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLinked();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string provider_id = 1;
 * @return {string}
 */
proto.no.jotta.openapi.auth.v2.LinkedIdentity.prototype.getProviderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.auth.v2.LinkedIdentity} returns this
 */
proto.no.jotta.openapi.auth.v2.LinkedIdentity.prototype.setProviderId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string provider_name = 2;
 * @return {string}
 */
proto.no.jotta.openapi.auth.v2.LinkedIdentity.prototype.getProviderName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.auth.v2.LinkedIdentity} returns this
 */
proto.no.jotta.openapi.auth.v2.LinkedIdentity.prototype.setProviderName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool linked = 3;
 * @return {boolean}
 */
proto.no.jotta.openapi.auth.v2.LinkedIdentity.prototype.getLinked = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.openapi.auth.v2.LinkedIdentity} returns this
 */
proto.no.jotta.openapi.auth.v2.LinkedIdentity.prototype.setLinked = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.auth.v2.ListSessionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.auth.v2.ListSessionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.auth.v2.ListSessionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.ListSessionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.auth.v2.ListSessionsRequest}
 */
proto.no.jotta.openapi.auth.v2.ListSessionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.auth.v2.ListSessionsRequest;
  return proto.no.jotta.openapi.auth.v2.ListSessionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.auth.v2.ListSessionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.auth.v2.ListSessionsRequest}
 */
proto.no.jotta.openapi.auth.v2.ListSessionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.auth.v2.ListSessionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.auth.v2.ListSessionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.auth.v2.ListSessionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.ListSessionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.auth.v2.ListSessionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.auth.v2.ListSessionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.auth.v2.ListSessionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.auth.v2.ListSessionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.ListSessionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    sessionsList: jspb.Message.toObjectList(msg.getSessionsList(),
    proto.no.jotta.openapi.auth.v2.Session.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.auth.v2.ListSessionsResponse}
 */
proto.no.jotta.openapi.auth.v2.ListSessionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.auth.v2.ListSessionsResponse;
  return proto.no.jotta.openapi.auth.v2.ListSessionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.auth.v2.ListSessionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.auth.v2.ListSessionsResponse}
 */
proto.no.jotta.openapi.auth.v2.ListSessionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.auth.v2.Session;
      reader.readMessage(value,proto.no.jotta.openapi.auth.v2.Session.deserializeBinaryFromReader);
      msg.addSessions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.auth.v2.ListSessionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.auth.v2.ListSessionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.auth.v2.ListSessionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.ListSessionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.no.jotta.openapi.auth.v2.Session.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Session sessions = 1;
 * @return {!Array<!proto.no.jotta.openapi.auth.v2.Session>}
 */
proto.no.jotta.openapi.auth.v2.ListSessionsResponse.prototype.getSessionsList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.auth.v2.Session>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.openapi.auth.v2.Session, 1));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.auth.v2.Session>} value
 * @return {!proto.no.jotta.openapi.auth.v2.ListSessionsResponse} returns this
*/
proto.no.jotta.openapi.auth.v2.ListSessionsResponse.prototype.setSessionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.no.jotta.openapi.auth.v2.Session=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.auth.v2.Session}
 */
proto.no.jotta.openapi.auth.v2.ListSessionsResponse.prototype.addSessions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.no.jotta.openapi.auth.v2.Session, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.auth.v2.ListSessionsResponse} returns this
 */
proto.no.jotta.openapi.auth.v2.ListSessionsResponse.prototype.clearSessionsList = function() {
  return this.setSessionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.auth.v2.DeleteSessionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.auth.v2.DeleteSessionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.auth.v2.DeleteSessionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.DeleteSessionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    sessionId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.auth.v2.DeleteSessionRequest}
 */
proto.no.jotta.openapi.auth.v2.DeleteSessionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.auth.v2.DeleteSessionRequest;
  return proto.no.jotta.openapi.auth.v2.DeleteSessionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.auth.v2.DeleteSessionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.auth.v2.DeleteSessionRequest}
 */
proto.no.jotta.openapi.auth.v2.DeleteSessionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.auth.v2.DeleteSessionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.auth.v2.DeleteSessionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.auth.v2.DeleteSessionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.DeleteSessionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string session_id = 1;
 * @return {string}
 */
proto.no.jotta.openapi.auth.v2.DeleteSessionRequest.prototype.getSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.auth.v2.DeleteSessionRequest} returns this
 */
proto.no.jotta.openapi.auth.v2.DeleteSessionRequest.prototype.setSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.auth.v2.DeleteSessionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.auth.v2.DeleteSessionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.auth.v2.DeleteSessionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.DeleteSessionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.auth.v2.DeleteSessionResponse}
 */
proto.no.jotta.openapi.auth.v2.DeleteSessionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.auth.v2.DeleteSessionResponse;
  return proto.no.jotta.openapi.auth.v2.DeleteSessionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.auth.v2.DeleteSessionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.auth.v2.DeleteSessionResponse}
 */
proto.no.jotta.openapi.auth.v2.DeleteSessionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.auth.v2.DeleteSessionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.auth.v2.DeleteSessionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.auth.v2.DeleteSessionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.DeleteSessionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.auth.v2.ListEventsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.auth.v2.ListEventsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.auth.v2.ListEventsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.ListEventsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.auth.v2.ListEventsRequest}
 */
proto.no.jotta.openapi.auth.v2.ListEventsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.auth.v2.ListEventsRequest;
  return proto.no.jotta.openapi.auth.v2.ListEventsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.auth.v2.ListEventsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.auth.v2.ListEventsRequest}
 */
proto.no.jotta.openapi.auth.v2.ListEventsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.auth.v2.ListEventsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.auth.v2.ListEventsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.auth.v2.ListEventsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.ListEventsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.auth.v2.ListEventsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.auth.v2.ListEventsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.auth.v2.ListEventsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.auth.v2.ListEventsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.ListEventsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    eventsList: jspb.Message.toObjectList(msg.getEventsList(),
    proto.no.jotta.openapi.auth.v2.Event.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.auth.v2.ListEventsResponse}
 */
proto.no.jotta.openapi.auth.v2.ListEventsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.auth.v2.ListEventsResponse;
  return proto.no.jotta.openapi.auth.v2.ListEventsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.auth.v2.ListEventsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.auth.v2.ListEventsResponse}
 */
proto.no.jotta.openapi.auth.v2.ListEventsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.auth.v2.Event;
      reader.readMessage(value,proto.no.jotta.openapi.auth.v2.Event.deserializeBinaryFromReader);
      msg.addEvents(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.auth.v2.ListEventsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.auth.v2.ListEventsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.auth.v2.ListEventsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.ListEventsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEventsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.no.jotta.openapi.auth.v2.Event.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Event events = 1;
 * @return {!Array<!proto.no.jotta.openapi.auth.v2.Event>}
 */
proto.no.jotta.openapi.auth.v2.ListEventsResponse.prototype.getEventsList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.auth.v2.Event>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.openapi.auth.v2.Event, 1));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.auth.v2.Event>} value
 * @return {!proto.no.jotta.openapi.auth.v2.ListEventsResponse} returns this
*/
proto.no.jotta.openapi.auth.v2.ListEventsResponse.prototype.setEventsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.no.jotta.openapi.auth.v2.Event=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.auth.v2.Event}
 */
proto.no.jotta.openapi.auth.v2.ListEventsResponse.prototype.addEvents = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.no.jotta.openapi.auth.v2.Event, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.auth.v2.ListEventsResponse} returns this
 */
proto.no.jotta.openapi.auth.v2.ListEventsResponse.prototype.clearEventsList = function() {
  return this.setEventsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.auth.v2.GenerateLoginTokenRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.auth.v2.GenerateLoginTokenRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.auth.v2.GenerateLoginTokenRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.GenerateLoginTokenRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    credentials: (f = msg.getCredentials()) && no_jotta_openapi_credentials_pb.Credentials.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.auth.v2.GenerateLoginTokenRequest}
 */
proto.no.jotta.openapi.auth.v2.GenerateLoginTokenRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.auth.v2.GenerateLoginTokenRequest;
  return proto.no.jotta.openapi.auth.v2.GenerateLoginTokenRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.auth.v2.GenerateLoginTokenRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.auth.v2.GenerateLoginTokenRequest}
 */
proto.no.jotta.openapi.auth.v2.GenerateLoginTokenRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new no_jotta_openapi_credentials_pb.Credentials;
      reader.readMessage(value,no_jotta_openapi_credentials_pb.Credentials.deserializeBinaryFromReader);
      msg.setCredentials(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.auth.v2.GenerateLoginTokenRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.auth.v2.GenerateLoginTokenRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.auth.v2.GenerateLoginTokenRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.GenerateLoginTokenRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCredentials();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      no_jotta_openapi_credentials_pb.Credentials.serializeBinaryToWriter
    );
  }
};


/**
 * optional no.jotta.openapi.Credentials credentials = 1;
 * @return {?proto.no.jotta.openapi.Credentials}
 */
proto.no.jotta.openapi.auth.v2.GenerateLoginTokenRequest.prototype.getCredentials = function() {
  return /** @type{?proto.no.jotta.openapi.Credentials} */ (
    jspb.Message.getWrapperField(this, no_jotta_openapi_credentials_pb.Credentials, 1));
};


/**
 * @param {?proto.no.jotta.openapi.Credentials|undefined} value
 * @return {!proto.no.jotta.openapi.auth.v2.GenerateLoginTokenRequest} returns this
*/
proto.no.jotta.openapi.auth.v2.GenerateLoginTokenRequest.prototype.setCredentials = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.auth.v2.GenerateLoginTokenRequest} returns this
 */
proto.no.jotta.openapi.auth.v2.GenerateLoginTokenRequest.prototype.clearCredentials = function() {
  return this.setCredentials(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.auth.v2.GenerateLoginTokenRequest.prototype.hasCredentials = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.auth.v2.GenerateLoginTokenResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.auth.v2.GenerateLoginTokenResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.auth.v2.GenerateLoginTokenResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.GenerateLoginTokenResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    challenges: (f = msg.getChallenges()) && no_jotta_openapi_credentials_pb.Challenges.toObject(includeInstance, f),
    token: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.auth.v2.GenerateLoginTokenResponse}
 */
proto.no.jotta.openapi.auth.v2.GenerateLoginTokenResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.auth.v2.GenerateLoginTokenResponse;
  return proto.no.jotta.openapi.auth.v2.GenerateLoginTokenResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.auth.v2.GenerateLoginTokenResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.auth.v2.GenerateLoginTokenResponse}
 */
proto.no.jotta.openapi.auth.v2.GenerateLoginTokenResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new no_jotta_openapi_credentials_pb.Challenges;
      reader.readMessage(value,no_jotta_openapi_credentials_pb.Challenges.deserializeBinaryFromReader);
      msg.setChallenges(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.auth.v2.GenerateLoginTokenResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.auth.v2.GenerateLoginTokenResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.auth.v2.GenerateLoginTokenResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.GenerateLoginTokenResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChallenges();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      no_jotta_openapi_credentials_pb.Challenges.serializeBinaryToWriter
    );
  }
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional no.jotta.openapi.Challenges challenges = 1;
 * @return {?proto.no.jotta.openapi.Challenges}
 */
proto.no.jotta.openapi.auth.v2.GenerateLoginTokenResponse.prototype.getChallenges = function() {
  return /** @type{?proto.no.jotta.openapi.Challenges} */ (
    jspb.Message.getWrapperField(this, no_jotta_openapi_credentials_pb.Challenges, 1));
};


/**
 * @param {?proto.no.jotta.openapi.Challenges|undefined} value
 * @return {!proto.no.jotta.openapi.auth.v2.GenerateLoginTokenResponse} returns this
*/
proto.no.jotta.openapi.auth.v2.GenerateLoginTokenResponse.prototype.setChallenges = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.auth.v2.GenerateLoginTokenResponse} returns this
 */
proto.no.jotta.openapi.auth.v2.GenerateLoginTokenResponse.prototype.clearChallenges = function() {
  return this.setChallenges(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.auth.v2.GenerateLoginTokenResponse.prototype.hasChallenges = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string token = 2;
 * @return {string}
 */
proto.no.jotta.openapi.auth.v2.GenerateLoginTokenResponse.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.auth.v2.GenerateLoginTokenResponse} returns this
 */
proto.no.jotta.openapi.auth.v2.GenerateLoginTokenResponse.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesRequest}
 */
proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesRequest;
  return proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesRequest}
 */
proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    linkedIdentitiesList: jspb.Message.toObjectList(msg.getLinkedIdentitiesList(),
    proto.no.jotta.openapi.auth.v2.LinkedIdentity.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesResponse}
 */
proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesResponse;
  return proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesResponse}
 */
proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.auth.v2.LinkedIdentity;
      reader.readMessage(value,proto.no.jotta.openapi.auth.v2.LinkedIdentity.deserializeBinaryFromReader);
      msg.addLinkedIdentities(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLinkedIdentitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.no.jotta.openapi.auth.v2.LinkedIdentity.serializeBinaryToWriter
    );
  }
};


/**
 * repeated LinkedIdentity linked_identities = 1;
 * @return {!Array<!proto.no.jotta.openapi.auth.v2.LinkedIdentity>}
 */
proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesResponse.prototype.getLinkedIdentitiesList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.auth.v2.LinkedIdentity>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.openapi.auth.v2.LinkedIdentity, 1));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.auth.v2.LinkedIdentity>} value
 * @return {!proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesResponse} returns this
*/
proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesResponse.prototype.setLinkedIdentitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.no.jotta.openapi.auth.v2.LinkedIdentity=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.auth.v2.LinkedIdentity}
 */
proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesResponse.prototype.addLinkedIdentities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.no.jotta.openapi.auth.v2.LinkedIdentity, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesResponse} returns this
 */
proto.no.jotta.openapi.auth.v2.ListLinkedIdentitiesResponse.prototype.clearLinkedIdentitiesList = function() {
  return this.setLinkedIdentitiesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    providerId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    redirectUrl: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingRequest}
 */
proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingRequest;
  return proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingRequest}
 */
proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProviderId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRedirectUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProviderId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRedirectUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string provider_id = 1;
 * @return {string}
 */
proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingRequest.prototype.getProviderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingRequest} returns this
 */
proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingRequest.prototype.setProviderId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string redirect_url = 2;
 * @return {string}
 */
proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingRequest.prototype.getRedirectUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingRequest} returns this
 */
proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingRequest.prototype.setRedirectUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    redirectUrl: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingResponse}
 */
proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingResponse;
  return proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingResponse}
 */
proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRedirectUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRedirectUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string redirect_url = 1;
 * @return {string}
 */
proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingResponse.prototype.getRedirectUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingResponse} returns this
 */
proto.no.jotta.openapi.auth.v2.InitializeIdentityLinkingResponse.prototype.setRedirectUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.auth.v2.UnlinkIdentityRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.auth.v2.UnlinkIdentityRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.auth.v2.UnlinkIdentityRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.UnlinkIdentityRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    providerId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.auth.v2.UnlinkIdentityRequest}
 */
proto.no.jotta.openapi.auth.v2.UnlinkIdentityRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.auth.v2.UnlinkIdentityRequest;
  return proto.no.jotta.openapi.auth.v2.UnlinkIdentityRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.auth.v2.UnlinkIdentityRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.auth.v2.UnlinkIdentityRequest}
 */
proto.no.jotta.openapi.auth.v2.UnlinkIdentityRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProviderId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.auth.v2.UnlinkIdentityRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.auth.v2.UnlinkIdentityRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.auth.v2.UnlinkIdentityRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.UnlinkIdentityRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProviderId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string provider_id = 1;
 * @return {string}
 */
proto.no.jotta.openapi.auth.v2.UnlinkIdentityRequest.prototype.getProviderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.auth.v2.UnlinkIdentityRequest} returns this
 */
proto.no.jotta.openapi.auth.v2.UnlinkIdentityRequest.prototype.setProviderId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.auth.v2.UnlinkIdentityResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.auth.v2.UnlinkIdentityResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.auth.v2.UnlinkIdentityResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.UnlinkIdentityResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.auth.v2.UnlinkIdentityResponse}
 */
proto.no.jotta.openapi.auth.v2.UnlinkIdentityResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.auth.v2.UnlinkIdentityResponse;
  return proto.no.jotta.openapi.auth.v2.UnlinkIdentityResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.auth.v2.UnlinkIdentityResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.auth.v2.UnlinkIdentityResponse}
 */
proto.no.jotta.openapi.auth.v2.UnlinkIdentityResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.auth.v2.UnlinkIdentityResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.auth.v2.UnlinkIdentityResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.auth.v2.UnlinkIdentityResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.UnlinkIdentityResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.no.jotta.openapi.auth.v2.InitializeTFARequest.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFARequest.TypeCase = {
  TYPE_NOT_SET: 0,
  TOTP: 1,
  SMS: 2
};

/**
 * @return {proto.no.jotta.openapi.auth.v2.InitializeTFARequest.TypeCase}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFARequest.prototype.getTypeCase = function() {
  return /** @type {proto.no.jotta.openapi.auth.v2.InitializeTFARequest.TypeCase} */(jspb.Message.computeOneofCase(this, proto.no.jotta.openapi.auth.v2.InitializeTFARequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFARequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.auth.v2.InitializeTFARequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.auth.v2.InitializeTFARequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.InitializeTFARequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    totp: (f = msg.getTotp()) && proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeTOTPRequest.toObject(includeInstance, f),
    sms: (f = msg.getSms()) && proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeSMSTFARequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.auth.v2.InitializeTFARequest}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFARequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.auth.v2.InitializeTFARequest;
  return proto.no.jotta.openapi.auth.v2.InitializeTFARequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.auth.v2.InitializeTFARequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.auth.v2.InitializeTFARequest}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFARequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeTOTPRequest;
      reader.readMessage(value,proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeTOTPRequest.deserializeBinaryFromReader);
      msg.setTotp(value);
      break;
    case 2:
      var value = new proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeSMSTFARequest;
      reader.readMessage(value,proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeSMSTFARequest.deserializeBinaryFromReader);
      msg.setSms(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFARequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.auth.v2.InitializeTFARequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.auth.v2.InitializeTFARequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.InitializeTFARequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotp();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeTOTPRequest.serializeBinaryToWriter
    );
  }
  f = message.getSms();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeSMSTFARequest.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeTOTPRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeTOTPRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeTOTPRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeTOTPRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeTOTPRequest}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeTOTPRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeTOTPRequest;
  return proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeTOTPRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeTOTPRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeTOTPRequest}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeTOTPRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeTOTPRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeTOTPRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeTOTPRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeTOTPRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeSMSTFARequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeSMSTFARequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeSMSTFARequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeSMSTFARequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    phoneNumber: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeSMSTFARequest}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeSMSTFARequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeSMSTFARequest;
  return proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeSMSTFARequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeSMSTFARequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeSMSTFARequest}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeSMSTFARequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeSMSTFARequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeSMSTFARequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeSMSTFARequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeSMSTFARequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPhoneNumber();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string phone_number = 1;
 * @return {string}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeSMSTFARequest.prototype.getPhoneNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeSMSTFARequest} returns this
 */
proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeSMSTFARequest.prototype.setPhoneNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional InitializeTOTPRequest totp = 1;
 * @return {?proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeTOTPRequest}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFARequest.prototype.getTotp = function() {
  return /** @type{?proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeTOTPRequest} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeTOTPRequest, 1));
};


/**
 * @param {?proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeTOTPRequest|undefined} value
 * @return {!proto.no.jotta.openapi.auth.v2.InitializeTFARequest} returns this
*/
proto.no.jotta.openapi.auth.v2.InitializeTFARequest.prototype.setTotp = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.no.jotta.openapi.auth.v2.InitializeTFARequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.auth.v2.InitializeTFARequest} returns this
 */
proto.no.jotta.openapi.auth.v2.InitializeTFARequest.prototype.clearTotp = function() {
  return this.setTotp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFARequest.prototype.hasTotp = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional InitializeSMSTFARequest sms = 2;
 * @return {?proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeSMSTFARequest}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFARequest.prototype.getSms = function() {
  return /** @type{?proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeSMSTFARequest} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeSMSTFARequest, 2));
};


/**
 * @param {?proto.no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeSMSTFARequest|undefined} value
 * @return {!proto.no.jotta.openapi.auth.v2.InitializeTFARequest} returns this
*/
proto.no.jotta.openapi.auth.v2.InitializeTFARequest.prototype.setSms = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.no.jotta.openapi.auth.v2.InitializeTFARequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.auth.v2.InitializeTFARequest} returns this
 */
proto.no.jotta.openapi.auth.v2.InitializeTFARequest.prototype.clearSms = function() {
  return this.setSms(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFARequest.prototype.hasSms = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.TypeCase = {
  TYPE_NOT_SET: 0,
  TOTP: 1,
  SMS: 2
};

/**
 * @return {proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.TypeCase}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.prototype.getTypeCase = function() {
  return /** @type {proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.TypeCase} */(jspb.Message.computeOneofCase(this, proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.auth.v2.InitializeTFAResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    totp: (f = msg.getTotp()) && proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse.toObject(includeInstance, f),
    sms: (f = msg.getSms()) && proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeSMSTFAResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.auth.v2.InitializeTFAResponse}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.auth.v2.InitializeTFAResponse;
  return proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.auth.v2.InitializeTFAResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.auth.v2.InitializeTFAResponse}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse;
      reader.readMessage(value,proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse.deserializeBinaryFromReader);
      msg.setTotp(value);
      break;
    case 2:
      var value = new proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeSMSTFAResponse;
      reader.readMessage(value,proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeSMSTFAResponse.deserializeBinaryFromReader);
      msg.setSms(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.auth.v2.InitializeTFAResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotp();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse.serializeBinaryToWriter
    );
  }
  f = message.getSms();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeSMSTFAResponse.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    authenticatorUri: jspb.Message.getFieldWithDefault(msg, 1, ""),
    secret: jspb.Message.getFieldWithDefault(msg, 2, ""),
    recoveryCodesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse;
  return proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthenticatorUri(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecret(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addRecoveryCodes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuthenticatorUri();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSecret();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRecoveryCodesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional string authenticator_uri = 1;
 * @return {string}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse.prototype.getAuthenticatorUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse} returns this
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse.prototype.setAuthenticatorUri = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string secret = 2;
 * @return {string}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse.prototype.getSecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse} returns this
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse.prototype.setSecret = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string recovery_codes = 3;
 * @return {!Array<string>}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse.prototype.getRecoveryCodesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse} returns this
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse.prototype.setRecoveryCodesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse} returns this
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse.prototype.addRecoveryCodes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse} returns this
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse.prototype.clearRecoveryCodesList = function() {
  return this.setRecoveryCodesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeSMSTFAResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeSMSTFAResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeSMSTFAResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeSMSTFAResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    verificationId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeSMSTFAResponse}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeSMSTFAResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeSMSTFAResponse;
  return proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeSMSTFAResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeSMSTFAResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeSMSTFAResponse}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeSMSTFAResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVerificationId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeSMSTFAResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeSMSTFAResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeSMSTFAResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeSMSTFAResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVerificationId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string verification_id = 1;
 * @return {string}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeSMSTFAResponse.prototype.getVerificationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeSMSTFAResponse} returns this
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeSMSTFAResponse.prototype.setVerificationId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional InitializeTOTPResponse totp = 1;
 * @return {?proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.prototype.getTotp = function() {
  return /** @type{?proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse, 1));
};


/**
 * @param {?proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse|undefined} value
 * @return {!proto.no.jotta.openapi.auth.v2.InitializeTFAResponse} returns this
*/
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.prototype.setTotp = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.auth.v2.InitializeTFAResponse} returns this
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.prototype.clearTotp = function() {
  return this.setTotp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.prototype.hasTotp = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional InitializeSMSTFAResponse sms = 2;
 * @return {?proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeSMSTFAResponse}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.prototype.getSms = function() {
  return /** @type{?proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeSMSTFAResponse} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeSMSTFAResponse, 2));
};


/**
 * @param {?proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeSMSTFAResponse|undefined} value
 * @return {!proto.no.jotta.openapi.auth.v2.InitializeTFAResponse} returns this
*/
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.prototype.setSms = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.auth.v2.InitializeTFAResponse} returns this
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.prototype.clearSms = function() {
  return this.setSms(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.auth.v2.InitializeTFAResponse.prototype.hasSms = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.TypeCase = {
  TYPE_NOT_SET: 0,
  TOTP: 1,
  SMS: 2
};

/**
 * @return {proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.TypeCase}
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.prototype.getTypeCase = function() {
  return /** @type {proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.TypeCase} */(jspb.Message.computeOneofCase(this, proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.auth.v2.ConfirmTFARequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    totp: (f = msg.getTotp()) && proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmTOTPRequest.toObject(includeInstance, f),
    sms: (f = msg.getSms()) && proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmSMSTFARequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.auth.v2.ConfirmTFARequest}
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.auth.v2.ConfirmTFARequest;
  return proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.auth.v2.ConfirmTFARequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.auth.v2.ConfirmTFARequest}
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmTOTPRequest;
      reader.readMessage(value,proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmTOTPRequest.deserializeBinaryFromReader);
      msg.setTotp(value);
      break;
    case 2:
      var value = new proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmSMSTFARequest;
      reader.readMessage(value,proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmSMSTFARequest.deserializeBinaryFromReader);
      msg.setSms(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.auth.v2.ConfirmTFARequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotp();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmTOTPRequest.serializeBinaryToWriter
    );
  }
  f = message.getSms();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmSMSTFARequest.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmTOTPRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmTOTPRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmTOTPRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmTOTPRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    verificationCode: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmTOTPRequest}
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmTOTPRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmTOTPRequest;
  return proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmTOTPRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmTOTPRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmTOTPRequest}
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmTOTPRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVerificationCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmTOTPRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmTOTPRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmTOTPRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmTOTPRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVerificationCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string verification_code = 1;
 * @return {string}
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmTOTPRequest.prototype.getVerificationCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmTOTPRequest} returns this
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmTOTPRequest.prototype.setVerificationCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmSMSTFARequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmSMSTFARequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmSMSTFARequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmSMSTFARequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    verificationId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    verificationCode: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmSMSTFARequest}
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmSMSTFARequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmSMSTFARequest;
  return proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmSMSTFARequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmSMSTFARequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmSMSTFARequest}
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmSMSTFARequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVerificationId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVerificationCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmSMSTFARequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmSMSTFARequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmSMSTFARequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmSMSTFARequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVerificationId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVerificationCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string verification_id = 1;
 * @return {string}
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmSMSTFARequest.prototype.getVerificationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmSMSTFARequest} returns this
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmSMSTFARequest.prototype.setVerificationId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string verification_code = 2;
 * @return {string}
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmSMSTFARequest.prototype.getVerificationCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmSMSTFARequest} returns this
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmSMSTFARequest.prototype.setVerificationCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional ConfirmTOTPRequest totp = 1;
 * @return {?proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmTOTPRequest}
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.prototype.getTotp = function() {
  return /** @type{?proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmTOTPRequest} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmTOTPRequest, 1));
};


/**
 * @param {?proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmTOTPRequest|undefined} value
 * @return {!proto.no.jotta.openapi.auth.v2.ConfirmTFARequest} returns this
*/
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.prototype.setTotp = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.auth.v2.ConfirmTFARequest} returns this
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.prototype.clearTotp = function() {
  return this.setTotp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.prototype.hasTotp = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ConfirmSMSTFARequest sms = 2;
 * @return {?proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmSMSTFARequest}
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.prototype.getSms = function() {
  return /** @type{?proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmSMSTFARequest} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmSMSTFARequest, 2));
};


/**
 * @param {?proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmSMSTFARequest|undefined} value
 * @return {!proto.no.jotta.openapi.auth.v2.ConfirmTFARequest} returns this
*/
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.prototype.setSms = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.auth.v2.ConfirmTFARequest} returns this
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.prototype.clearSms = function() {
  return this.setSms(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFARequest.prototype.hasSms = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFAResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.auth.v2.ConfirmTFAResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.auth.v2.ConfirmTFAResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFAResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.auth.v2.ConfirmTFAResponse}
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFAResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.auth.v2.ConfirmTFAResponse;
  return proto.no.jotta.openapi.auth.v2.ConfirmTFAResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.auth.v2.ConfirmTFAResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.auth.v2.ConfirmTFAResponse}
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFAResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.no.jotta.openapi.auth.v2.ConfirmTFAResponse.ConfirmTFAStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFAResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.auth.v2.ConfirmTFAResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.auth.v2.ConfirmTFAResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFAResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFAResponse.ConfirmTFAStatus = {
  UNKNOWN_TFA_STATUS: 0,
  OK: 1,
  INVALID: 2
};

/**
 * optional ConfirmTFAStatus status = 1;
 * @return {!proto.no.jotta.openapi.auth.v2.ConfirmTFAResponse.ConfirmTFAStatus}
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFAResponse.prototype.getStatus = function() {
  return /** @type {!proto.no.jotta.openapi.auth.v2.ConfirmTFAResponse.ConfirmTFAStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.no.jotta.openapi.auth.v2.ConfirmTFAResponse.ConfirmTFAStatus} value
 * @return {!proto.no.jotta.openapi.auth.v2.ConfirmTFAResponse} returns this
 */
proto.no.jotta.openapi.auth.v2.ConfirmTFAResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.auth.v2.DisableTFARequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.auth.v2.DisableTFARequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.auth.v2.DisableTFARequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.DisableTFARequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    credentials: (f = msg.getCredentials()) && no_jotta_openapi_credentials_pb.Credentials.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.auth.v2.DisableTFARequest}
 */
proto.no.jotta.openapi.auth.v2.DisableTFARequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.auth.v2.DisableTFARequest;
  return proto.no.jotta.openapi.auth.v2.DisableTFARequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.auth.v2.DisableTFARequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.auth.v2.DisableTFARequest}
 */
proto.no.jotta.openapi.auth.v2.DisableTFARequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new no_jotta_openapi_credentials_pb.Credentials;
      reader.readMessage(value,no_jotta_openapi_credentials_pb.Credentials.deserializeBinaryFromReader);
      msg.setCredentials(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.auth.v2.DisableTFARequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.auth.v2.DisableTFARequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.auth.v2.DisableTFARequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.DisableTFARequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCredentials();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      no_jotta_openapi_credentials_pb.Credentials.serializeBinaryToWriter
    );
  }
};


/**
 * optional no.jotta.openapi.Credentials credentials = 1;
 * @return {?proto.no.jotta.openapi.Credentials}
 */
proto.no.jotta.openapi.auth.v2.DisableTFARequest.prototype.getCredentials = function() {
  return /** @type{?proto.no.jotta.openapi.Credentials} */ (
    jspb.Message.getWrapperField(this, no_jotta_openapi_credentials_pb.Credentials, 1));
};


/**
 * @param {?proto.no.jotta.openapi.Credentials|undefined} value
 * @return {!proto.no.jotta.openapi.auth.v2.DisableTFARequest} returns this
*/
proto.no.jotta.openapi.auth.v2.DisableTFARequest.prototype.setCredentials = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.auth.v2.DisableTFARequest} returns this
 */
proto.no.jotta.openapi.auth.v2.DisableTFARequest.prototype.clearCredentials = function() {
  return this.setCredentials(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.auth.v2.DisableTFARequest.prototype.hasCredentials = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.auth.v2.DisableTFAResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.auth.v2.DisableTFAResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.auth.v2.DisableTFAResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.DisableTFAResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    challenges: (f = msg.getChallenges()) && no_jotta_openapi_credentials_pb.Challenges.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.auth.v2.DisableTFAResponse}
 */
proto.no.jotta.openapi.auth.v2.DisableTFAResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.auth.v2.DisableTFAResponse;
  return proto.no.jotta.openapi.auth.v2.DisableTFAResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.auth.v2.DisableTFAResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.auth.v2.DisableTFAResponse}
 */
proto.no.jotta.openapi.auth.v2.DisableTFAResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new no_jotta_openapi_credentials_pb.Challenges;
      reader.readMessage(value,no_jotta_openapi_credentials_pb.Challenges.deserializeBinaryFromReader);
      msg.setChallenges(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.auth.v2.DisableTFAResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.auth.v2.DisableTFAResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.auth.v2.DisableTFAResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.DisableTFAResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChallenges();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      no_jotta_openapi_credentials_pb.Challenges.serializeBinaryToWriter
    );
  }
};


/**
 * optional no.jotta.openapi.Challenges challenges = 1;
 * @return {?proto.no.jotta.openapi.Challenges}
 */
proto.no.jotta.openapi.auth.v2.DisableTFAResponse.prototype.getChallenges = function() {
  return /** @type{?proto.no.jotta.openapi.Challenges} */ (
    jspb.Message.getWrapperField(this, no_jotta_openapi_credentials_pb.Challenges, 1));
};


/**
 * @param {?proto.no.jotta.openapi.Challenges|undefined} value
 * @return {!proto.no.jotta.openapi.auth.v2.DisableTFAResponse} returns this
*/
proto.no.jotta.openapi.auth.v2.DisableTFAResponse.prototype.setChallenges = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.auth.v2.DisableTFAResponse} returns this
 */
proto.no.jotta.openapi.auth.v2.DisableTFAResponse.prototype.clearChallenges = function() {
  return this.setChallenges(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.auth.v2.DisableTFAResponse.prototype.hasChallenges = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.auth.v2.RegisterSessionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.auth.v2.RegisterSessionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.auth.v2.RegisterSessionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.RegisterSessionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    deviceName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userAgent: jspb.Message.getFieldWithDefault(msg, 2, ""),
    appVersion: jspb.Message.getFieldWithDefault(msg, 3, ""),
    deviceId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    appId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    appType: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.auth.v2.RegisterSessionRequest}
 */
proto.no.jotta.openapi.auth.v2.RegisterSessionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.auth.v2.RegisterSessionRequest;
  return proto.no.jotta.openapi.auth.v2.RegisterSessionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.auth.v2.RegisterSessionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.auth.v2.RegisterSessionRequest}
 */
proto.no.jotta.openapi.auth.v2.RegisterSessionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserAgent(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppVersion(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.auth.v2.RegisterSessionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.auth.v2.RegisterSessionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.auth.v2.RegisterSessionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.RegisterSessionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDeviceName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserAgent();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAppVersion();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDeviceId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAppId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAppType();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string device_name = 1;
 * @return {string}
 */
proto.no.jotta.openapi.auth.v2.RegisterSessionRequest.prototype.getDeviceName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.auth.v2.RegisterSessionRequest} returns this
 */
proto.no.jotta.openapi.auth.v2.RegisterSessionRequest.prototype.setDeviceName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_agent = 2;
 * @return {string}
 */
proto.no.jotta.openapi.auth.v2.RegisterSessionRequest.prototype.getUserAgent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.auth.v2.RegisterSessionRequest} returns this
 */
proto.no.jotta.openapi.auth.v2.RegisterSessionRequest.prototype.setUserAgent = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string app_version = 3;
 * @return {string}
 */
proto.no.jotta.openapi.auth.v2.RegisterSessionRequest.prototype.getAppVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.auth.v2.RegisterSessionRequest} returns this
 */
proto.no.jotta.openapi.auth.v2.RegisterSessionRequest.prototype.setAppVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string device_id = 4;
 * @return {string}
 */
proto.no.jotta.openapi.auth.v2.RegisterSessionRequest.prototype.getDeviceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.auth.v2.RegisterSessionRequest} returns this
 */
proto.no.jotta.openapi.auth.v2.RegisterSessionRequest.prototype.setDeviceId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string app_id = 5;
 * @return {string}
 */
proto.no.jotta.openapi.auth.v2.RegisterSessionRequest.prototype.getAppId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.auth.v2.RegisterSessionRequest} returns this
 */
proto.no.jotta.openapi.auth.v2.RegisterSessionRequest.prototype.setAppId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string app_type = 6;
 * @return {string}
 */
proto.no.jotta.openapi.auth.v2.RegisterSessionRequest.prototype.getAppType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.auth.v2.RegisterSessionRequest} returns this
 */
proto.no.jotta.openapi.auth.v2.RegisterSessionRequest.prototype.setAppType = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.auth.v2.RegisterSessionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.auth.v2.RegisterSessionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.auth.v2.RegisterSessionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.RegisterSessionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    sessionId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.auth.v2.RegisterSessionResponse}
 */
proto.no.jotta.openapi.auth.v2.RegisterSessionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.auth.v2.RegisterSessionResponse;
  return proto.no.jotta.openapi.auth.v2.RegisterSessionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.auth.v2.RegisterSessionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.auth.v2.RegisterSessionResponse}
 */
proto.no.jotta.openapi.auth.v2.RegisterSessionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.auth.v2.RegisterSessionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.auth.v2.RegisterSessionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.auth.v2.RegisterSessionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.auth.v2.RegisterSessionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string session_id = 1;
 * @return {string}
 */
proto.no.jotta.openapi.auth.v2.RegisterSessionResponse.prototype.getSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.auth.v2.RegisterSessionResponse} returns this
 */
proto.no.jotta.openapi.auth.v2.RegisterSessionResponse.prototype.setSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


goog.object.extend(exports, proto.no.jotta.openapi.auth.v2);
